var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleNavIcon = function SvgPeopleNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M7 9a4 4 0 1 1 8 0v1a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2zm2-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M13 13a4 4 0 0 1 8 0v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm2-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M1 13a4 4 0 0 1 8 0v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M7 18a4 4 0 0 1 8 0v1a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2zm2-7a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  })));
};
export default SvgPeopleNavIcon;